import { lambdaClient } from '../config/http.client';

/**
 * Generate a clean, professional title from questionnaire data or raw idea
 */
export const generateTitle = async (questionnaireData = null, idea = null, modelId = null) => {
  try {
    const response = await lambdaClient.post('/title/generate', {
      questionnaire_data: questionnaireData,
      idea: idea,
      model_id: modelId
    });

    // Backend returns { success: true, title: "..." }
    if (response.data.success && response.data.title) {
      return response.data.title;
    } else {
      throw new Error(response.data.error || 'Title generation failed');
    }
  } catch (error) {
    console.error('Title generation error:', error);
    // Return fallback title
    if (questionnaireData && questionnaireData.problem) {
      return `${questionnaireData.problem.substring(0, 50)}...`;
    } else if (idea) {
      return idea.split('\n')[0].substring(0, 50) + '...';
    }
    return 'Startup Idea Analysis';
  }
};

const titleService = {
  generateTitle
};

export default titleService;
